import { apiClient } from "../../shared/api/httpClient";

export const CHAT_PROTOCOL_VERSION = "1.0";

export async function listConversations() {
  const response = await apiClient.get("/chat/conversations/");
  return response.data;
}

export async function createDirectConversation(peerUserId) {
  const response = await apiClient.post("/chat/conversations/direct/", {
    peer_user_id: Number(peerUserId),
  });
  return response.data;
}

export async function listMessages(conversationId) {
  const response = await apiClient.get(`/chat/conversations/${conversationId}/messages/`);
  return response.data;
}

export async function markConversationRead(conversationId, lastReadSeq) {
  const response = await apiClient.post(`/chat/conversations/${conversationId}/read/`, {
    last_read_seq: lastReadSeq,
  });
  return response.data;
}

export async function requestRealtimeTicket() {
  const response = await apiClient.post("/chat/realtime/ticket/", {});
  return response.data.ticket;
}

export function createChatSocket(ticket) {
  const configuredBaseUrl = (
    import.meta.env.VITE_WS_BASE_URL
    || import.meta.env.VITE_API_BASE_URL
    || window.location.origin
  ).replace(/\/$/, "");
  const websocketUrl = configuredBaseUrl.replace(/^http/, "ws");
  return new WebSocket(`${websocketUrl}/ws/chat/?ticket=${encodeURIComponent(ticket)}`);
}
